var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3397 1V7.06351C26.0039 6.29776 24.4505 5.84456 22.7573 5.84456C17.5845 5.84456 13.6233 9.92337 13.6233 14.9554C13.6233 19.9876 17.5845 24.2851 22.7573 24.2851C24.4505 24.2851 26.0039 23.8163 27.3397 23.0193V24.2851H32V1H27.3397ZM22.7884 20.0031C20.4272 20.0031 18.2058 18.1591 18.2058 15.0024C18.2058 12.0644 20.4272 10.0797 22.7884 10.0797C25.1496 10.0797 27.3397 12.0644 27.3397 15.0024C27.3397 18.1434 25.1496 20.0031 22.7884 20.0031Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17079 24.2851C9.65497 24.2851 10.8582 23.0747 10.8582 21.5816C10.8582 20.0883 9.65497 18.8779 8.17079 18.8779C6.68658 18.8779 5.4834 20.0883 5.4834 21.5816C5.4834 23.0747 6.68658 24.2851 8.17079 24.2851Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84078 17.4089H10.501V5.70391H16.3418V1H0V5.70391H5.84078V17.4089Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cc350a7d.svg";
export { ForwardRef as ReactComponent };